import { render, staticRenderFns } from "./Additional.vue?vue&type=template&id=d4e6afea&scoped=true"
import script from "./Additional.vue?vue&type=script&lang=js"
export * from "./Additional.vue?vue&type=script&lang=js"
import style0 from "./Additional.vue?vue&type=style&index=0&id=d4e6afea&prod&lang=scss&scoped=true"
import style1 from "./Additional.vue?vue&type=style&index=1&id=d4e6afea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e6afea",
  null
  
)

export default component.exports